import { attr, belongsTo } from 'spraypaint'
import ApplicationRecord from './ApplicationRecord'

const AddonSheet = ApplicationRecord.extend({
  static: {
    jsonapiType: 'addon_sheets',
  },
  attrs: {
    addonId: attr(),
    orderPackageId: attr(),
    index: attr(),
    foreground: belongsTo(),
    foregroundId: attr(),
    hasDownloadableImage: attr({ persist: false }),
    seniorImageId: attr(),
    poseId: attr(),
    backgroundId: attr(),
    studentImageId: attr(),
    // Server-stamped charged price (read-only on the API; sending it is ignored)
    unitPrice: attr({ persist: false }),
    // The offer that granted this sheet, when one did (#5747). Server-stamped,
    // read-only: THE way to tell a free item from a bought copy of the same add-on.
    grantedByCouponId: attr({ persist: false }),
    createdAt: attr(),
    updatedAt: attr(),
    orderPackage: belongsTo(),
    addon: belongsTo(),
    pose: belongsTo(),
    background: belongsTo(),
    seniorImage: belongsTo(),
    studentImage: belongsTo(),
  },
})

export default AddonSheet
